import { ROUTES } from 'src/constants/routes.const';
import { stringifyUrl } from 'src/utils/stringifyUrl';

export type AprenderLearnSessionUrlOptions = {
  source?: string;
  pathwayNodeId?: number;
  back?: string;
};

export const getAprenderLearnSessionUrl = (
  languagePairId: number,
  sourceOrOptions?: string | AprenderLearnSessionUrlOptions,
): string => {
  const options =
    typeof sourceOrOptions === 'string' ? { source: sourceOrOptions } : (sourceOrOptions ?? {});

  const params: Record<string, string | number> = { language_pair_id: languagePairId };
  if (options.source) {
    params.source = options.source;
  }
  if (options.pathwayNodeId !== undefined) {
    params.pathway_node_id = options.pathwayNodeId;
  }
  if (options.back) {
    params.back = options.back;
  }
  return stringifyUrl(ROUTES.aprender.learn, params);
};
